import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { Dashboard } from '@/components/Dashboard';
import { buildDashboardViewModel, resolveDefaultDashboardMonth } from '@/application/dashboard';
import { useExpenses } from '@/hooks/useExpenses';

export function DashboardRoute() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { expenses, loading } = useExpenses();
  const monthParam = searchParams.get('month');

  useEffect(() => {
    if (loading || monthParam) return;

    const defaultMonth = resolveDefaultDashboardMonth(expenses);
    setSearchParams((current) => {
      const next = new URLSearchParams(current);
      next.set('month', defaultMonth);
      return next;
    }, { replace: true });
  }, [expenses, loading, monthParam, setSearchParams]);

  const month = monthParam || undefined;
  const viewModel = buildDashboardViewModel(expenses, month);

  return (
    <Dashboard
      loading={loading}
      month={viewModel.month}
      stats={viewModel.stats}
      categoryData={viewModel.categoryData}
      monthlyTrend={viewModel.monthlyTrend}
      recentExpenses={viewModel.recentExpenses}
      monthExpenses={viewModel.monthExpenses}
      onMonthChange={(value: string) => setSearchParams((current) => {
        const next = new URLSearchParams(current);
        next.set('month', value);
        return next;
      })}
    />
  );
}
